var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 30,
    fill: "none",
    viewBox: "0 0 136 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE9DB",
    fillRule: "evenodd",
    d: "M0 8.02V30h4.724V16.435l5.83 8.854h2.743l4.32-6.54.908-1.373-2.441-4.213-.908 1.378-3.235 4.908L4.378 8.02zM62.556 12.122h-3.52v13.722h3.52c4.37 0 6.726-2.329 6.726-6.861s-2.357-6.86-6.726-6.86m0-4.154c7.827 0 11.536 4.626 11.536 11.015s-3.709 11.015-11.536 11.015H54.32V7.968zM84.8 7.968c2.508 0 5.047.605 6.86 1.634v4.236c-1.783-1.27-4.17-1.906-6.528-1.876-2.297.03-3.445.666-3.445 1.967 0 3.662 11.576 2.3 11.576 9.835 0 4.751-3.809 6.234-8.252 6.234-2.931 0-5.652-.696-7.828-1.906v-4.328a13.54 13.54 0 0 0 7.496 2.24c2.448 0 3.96-.515 3.96-2.028 0-3.964-11.576-2.481-11.576-9.986 0-4.086 3.566-6.022 7.737-6.022M112.324 7.968v4.154h-10.781v4.69h9.839v4.122h-9.839v4.91h10.97v4.154H96.828V7.968zM116.32 29.998V7.968h4.432l10.247 14.383a47 47 0 0 1-.094-3.022V7.968h4.715v22.03h-4.432l-10.247-14.383c.063.913.094 2.014.094 3.022v11.361zM40.385 12.008a2.1 2.1 0 0 0-.279-1.186L38.46 7.97h-1.698l2.068 3.587c.08.14.107.302.074.452z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE9DB",
    fillRule: "evenodd",
    d: "m51.186 19.983-5.2 9.015A1.99 1.99 0 0 1 44.259 30h-10.4a1.99 1.99 0 0 1-1.728-1.002l-3.091-5.361-.851-1.473-1.258-2.18a2.01 2.01 0 0 1 0-2.002l5.2-9.014a1.99 1.99 0 0 1 1.727-.999h2.908l2.069 3.588c.08.14.106.3.073.451h-3.873l-4.023 6.977 1.827 3.165.748 1.3 1.448 2.511h8.046l4.023-6.976-4.023-6.977H40.39a2.1 2.1 0 0 0-.28-1.186L38.465 7.97h5.794a1.99 1.99 0 0 1 1.728.999l5.2 9.014c.355.62.355 1.38 0 2.001",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__mask0_13960_15861",
    width: 28,
    height: 24,
    x: 13,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.95.137H40.39v23.5H13.949z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo_svg__mask0_13960_15861)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F17900",
    fillRule: "evenodd",
    d: "M23.781 22.164v1.473h5.255l-.85-1.473zm16.327-11.342L38.462 7.97 34.56 1.202A2.13 2.13 0 0 0 32.715.137h-11.09c-.762 0-1.463.408-1.844 1.065l-5.549 9.62a2.14 2.14 0 0 0 0 2.13l.895 1.553 2.435 4.219 1.507 2.614v-2.945l-.601-1.046-2.435-4.223-.524-.907a.66.66 0 0 1 0-.66l5.544-9.617a.66.66 0 0 1 .572-.33h11.09c.235 0 .455.124.572.33l3.477 6.03 2.068 3.587c.08.139.106.3.074.451a.6.6 0 0 1-.074.21l-5.545 9.616a.64.64 0 0 1-.45.316l.747 1.3a2.13 2.13 0 0 0 .976-.878l5.548-9.62c.169-.294.26-.617.279-.944a2.1 2.1 0 0 0-.279-1.186",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE9DB",
    fillRule: "evenodd",
    d: "M23.78 7.97V30h-4.712V16.433l-.602.914-2.435-4.223 3.381-5.155z",
    clipRule: "evenodd"
  })));
};
export default SvgLogo;